import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

export const i18n = i18next
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    detection: {
      // order and from where user language should be detected
      order: ["localStorage", "navigator"],

      // keys or params to lookup language from
      lookupLocalStorage: "i18nextLng",
      // cache user language on
      caches: ["localStorage"],
      excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)
    },
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: {
          "First Name": "First Name",
          "Last Name": "Last Name",
          Email: "Email",
          "Phone Number": "Phone Number",
          "Zip Code": "Zip Code",
          "5 digit code": "5 digit code",
          "Exit Show": !window.IS_BRANDED ? "Exit Show" : "Exit Event",
          "Find Your Event": "Find Your Event",
          "Search below or use your current location":
            "Search below or use your current location",
          "Finding Your Show": "Finding Your Show",
          "Use My Location": "Use My Location",
          "Please enable location services to find nearby shows.":
            "Please enable location services to find nearby shows.",
          "Hey Artists": "Hey Artists",
          "Engage and reward your fans!": "Engage and reward your fans!",
          "Give your biggest fans the chance to interact with you in real time":
            "Give your biggest fans the chance to interact with you in real time",
          "Learn More!": "Learn More!",
          "Get Started": "Get Started",
          "We couldn't seem to find your location, please try again.":
            "We couldn't seem to find your location, please try again.",
          "We've encountered a server issue, please try again.":
            "We've encountered a server issue, please try again.",
          "Use of this site constitutes acceptance of our":
            "Use of this site constitutes acceptance of our",
          "User Agreement and Privacy Policy and Cookie Statement.":
            "User Agreement and Privacy Policy and Cookie Statement.",
          // `{cta}` and `{rules}` are resolved by splitSweepstakesDisclaimer,
          // not by i18next — the event builder can override this whole line.
          sweepstakesDisclaimer:
            "No purchase necessary. Void where prohibited. By clicking {cta} you acknowledge and accept the {rules}",
          "Official Rules": "Official Rules",
          Vote: "Vote",
          "Check In": "Check In",
          "Search by artist name or venue...":
            "Search by artist name or venue...",
          Submitting: "Submitting",
          "No matches found...": "No matches found...",
          "You have donated": "You have donated",
          "Join the Light Show?": "Join the Light Show?",
          "Turn your brightness up and hold your phone high.":
            "Turn your brightness up and hold your phone high.",
          "Tap the screen anytime to exit.": "Tap the screen anytime to exit.",
          Join: "Join",
          "Not Now": "Not Now",
          "Check In to Join": "Check In to Join",
          "Light up the crowd": "Light up the crowd",
          "Your phone is part of the show": "Your phone is part of the show",
          "Join in": "Join in",
          "Exit Light Show": "Exit Light Show",
        },
      },
      es: {
        translation: {
          "First Name": "Nombre",
          "Last Name": "Apellido",
          Email: "Correo Electrónico",
          "Phone Number": "Número de teléfono",
          "Zip Code": "Código Postal",
          "5 digit code": "Código de 5 dígitos",
          "Exit Show": !window.IS_BRANDED
            ? "Salir del Show"
            : "Salir del Evento",
          "Find Your Event": "Encuentra tu Evento",
          "Search below or use your current location":
            "Busca a continuación o usa tu ubicación actual",
          "Finding Your Show": "Encontrando tu Show",
          "Use My Location": "Usar mi Ubicación",
          "Please enable location services to find nearby shows.":
            "Por favor habilita los servicios de ubicación para encontrar shows cercanos.",
          "Hey Artists": "Hola Artistas",
          "Engage and reward your fans!": "Conecta y premia a tus fans",
          "Give your biggest fans the chance to interact with you in real time":
            "Brinda a tus más grandes fans la posibilidad de interactuar contigo en vivo",
          "Learn More!": "¡Aprende más!",
          "Get Started": "Comenzar",
          "We couldn't seem to find your location, please try again.":
            "No fue posible obtener tu ubicación, por favor intenta de nuevo.",
          "We've encountered a server issue, please try again.":
            "Ocurrió un error en el servidor, por favor intenta de nuevo.",
          "Use of this site constitutes acceptance of our":
            "El uso de este sitio implica aceptar nuestro",
          "User Agreement and Privacy Policy and Cookie Statement.":
            "Acuerdo de usuario, Política de privacidad y Declaración de cookies.",
          sweepstakesDisclaimer:
            "No se requiere una compra. No es válido en lugares donde este prohibido. Al hacer clic en {cta} reconoce y acepta las {rules}",
          "Official Rules": "Reglas oficiales",
          Vote: "Votar",
          "Check In": "Regístrate",
          "Search by artist name or venue...": "Buscar por artista o lugar...",
          Submitting: "Submitting",
          "No matches found...": "No matches found...",
          "You have donated": "You have donated",
          "Join the Light Show?": "¿Te unes al show de luces?",
          "Turn your brightness up and hold your phone high.":
            "Sube el brillo y levanta tu teléfono.",
          "Tap the screen anytime to exit.":
            "Toca la pantalla en cualquier momento para salir.",
          Join: "Unirme",
          "Not Now": "Ahora no",
          "Check In to Join": "Regístrate para unirte",
          "Light up the crowd": "Ilumina al público",
          "Your phone is part of the show": "Tu teléfono es parte del show",
          "Join in": "Unirme",
          "Exit Light Show": "Salir del show de luces",
        },
      },
      pt: {
        translation: {
          "First Name": "Nome",
          "Last Name": "Sobrenome",
          Email: "E-mail",
          "Phone Number": "Número de telefone",
          "Zip Code": "CEP",
          "5 digit code": "código de 5 dígitos",
          "Exit Show": !window.IS_BRANDED ? "Sair do Show" : "Sair do Evento",
          "Find Your Event": "Encontre seu evento",
          "Search below or use your current location":
            "Pesquise abaixo ou use sua localização atual",
          "Finding Your Show": "Encontrando seu show",
          "Use My Location": "Use minha localização",
          "Please enable location services to find nearby shows.":
            "Ative os serviços de localização para encontrar shows próximos.",
          "Hey Artists": "Olá, artistas",
          "Engage and reward your fans!": "Envolva e recompense seus fãs!",
          "Give your biggest fans the chance to interact with you in real time":
            "Dê aos seus maiores fãs a chance de interagir com você em tempo real",
          "Learn More!": "Saiba mais!",
          "Get Started": "Começar",
          "We couldn't seem to find your location, please try again.":
            "Não foi possível encontrar sua localização. Tente novamente.",
          "We've encountered a server issue, please try again.":
            "Encontramos um problema no servidor, tente novamente.",
          "Use of this site constitutes acceptance of our":
            "O uso deste site constitui a aceitação de nossos",
          "User Agreement and Privacy Policy and Cookie Statement.":
            "Contrato do usuário e política de privacidade e declaração de cookies.",
          sweepstakesDisclaimer:
            "Nenhuma compra necessária. Inválido onde proibido. Ao clicar em {cta}, você reconhece e aceita as {rules}",
          "Official Rules": "Regras oficiais",
          Vote: "Votar",
          "Check In": "Check-in",
          "Search by artist name or venue...":
            "Pesquise pelo nome do artista ou local...",
          Submitting: "Enviando",
          "No matches found...": "Nenhum resultado encontrado...",
          "You have donated": "Você doou",
          "Join the Light Show?": "Participar do show de luzes?",
          "Turn your brightness up and hold your phone high.":
            "Aumente o brilho e levante o celular.",
          "Tap the screen anytime to exit.":
            "Toque na tela a qualquer momento para sair.",
          Join: "Participar",
          "Not Now": "Agora não",
          "Check In to Join": "Faça check-in para participar",
          "Light up the crowd": "Ilumine o público",
          "Your phone is part of the show": "Seu celular faz parte do show",
          "Join in": "Participar",
          "Exit Light Show": "Sair do show de luzes",
        },
      },
      de: {
        translation: {
          "First Name": "Vorname",
          "Last Name": "Nachname",
          Email: "E-Mail",
          "Phone Number": "Telefonnummer",
          "Zip Code": "Postleitzahl",
          "5 digit code": "5-stelliger Code",
          "Exit Show": !window.IS_BRANDED
            ? "Show verlassen"
            : "Veranstaltung verlassen",
          "Find Your Event": "Finde dein Event",
          "Search below or use your current location":
            "Suche unten oder verwende deinen aktuellen Standort",
          "Finding Your Show": "Show wird gesucht",
          "Use My Location": "Meinen Standort verwenden",
          "Please enable location services to find nearby shows.":
            "Bitte aktiviere die Standortdienste, um nahegelegene Shows zu finden.",
          "Hey Artists": "Hallo Künstler",
          "Engage and reward your fans!": "Engagiere und belohne deine Fans!",
          "Give your biggest fans the chance to interact with you in real time":
            "Gib deinen größten Fans die Möglichkeit, in Echtzeit mit dir zu interagieren",
          "Learn More!": "Mehr erfahren!",
          "Get Started": "Loslegen",
          "We couldn't seem to find your location, please try again.":
            "Wir konnten deinen Standort nicht finden, bitte versuche es erneut.",
          "We've encountered a server issue, please try again.":
            "Es ist ein Serverfehler aufgetreten, bitte versuche es erneut.",
          "Use of this site constitutes acceptance of our":
            "Die Nutzung dieser Website stellt die Annahme unserer",
          "User Agreement and Privacy Policy and Cookie Statement.":
            "Nutzungsvereinbarung, Datenschutzrichtlinie und Cookie-Erklärung dar.",
          sweepstakesDisclaimer:
            "Kein Kauf erforderlich. Ungültig, wo verboten. Durch Klicken {cta} erkennst du an und akzeptierst die {rules}",
          "Official Rules": "Offizielle Regeln",
          Vote: "Abstimmen",
          "Check In": "Einchecken",
          "Search by artist name or venue...":
            "Nach Künstlername oder Veranstaltungsort suchen...",
          Submitting: "Wird gesendet",
          "No matches found...": "Keine Treffer gefunden...",
          "You have donated": "Du hast gespendet",
          "Join the Light Show?": "Bei der Lichtshow mitmachen?",
          "Turn your brightness up and hold your phone high.":
            "Dreh die Helligkeit hoch und halte dein Handy nach oben.",
          "Tap the screen anytime to exit.":
            "Tippe jederzeit auf den Bildschirm, um zu beenden.",
          Join: "Mitmachen",
          "Not Now": "Jetzt nicht",
          "Check In to Join": "Zum Mitmachen einchecken",
          "Light up the crowd": "Bring das Publikum zum Leuchten",
          "Your phone is part of the show": "Dein Handy ist Teil der Show",
          "Join in": "Mitmachen",
          "Exit Light Show": "Lichtshow beenden",
        },
      },
      fr: {
        translation: {
          "First Name": "Prénom",
          "Last Name": "Nom de famille",
          Email: "E-mail",
          "Phone Number": "Numéro de téléphone",
          "Zip Code": "Code postal",
          "5 digit code": "Code à 5 chiffres",
          "Exit Show": !window.IS_BRANDED
            ? "Quitter le spectacle"
            : "Quitter l'événement",
          "Find Your Event": "Trouvez votre événement",
          "Search below or use your current location":
            "Recherchez ci-dessous ou utilisez votre position actuelle",
          "Finding Your Show": "Recherche de votre spectacle",
          "Use My Location": "Utiliser ma position",
          "Please enable location services to find nearby shows.":
            "Veuillez activer les services de localisation pour trouver des spectacles à proximité.",
          "Hey Artists": "Salut les artistes",
          "Engage and reward your fans!": "Engagez et récompensez vos fans !",
          "Give your biggest fans the chance to interact with you in real time":
            "Offrez à vos plus grands fans la possibilité d'interagir avec vous en temps réel",
          "Learn More!": "En savoir plus !",
          "Get Started": "Commencer",
          "We couldn't seem to find your location, please try again.":
            "Nous n'avons pas pu trouver votre position, veuillez réessayer.",
          "We've encountered a server issue, please try again.":
            "Un problème de serveur est survenu, veuillez réessayer.",
          "Use of this site constitutes acceptance of our":
            "L'utilisation de ce site implique l'acceptation de nos",
          "User Agreement and Privacy Policy and Cookie Statement.":
            "Conditions d'utilisation, politique de confidentialité et déclaration relative aux cookies.",
          sweepstakesDisclaimer:
            "Aucun achat requis. Nul là où la loi l'interdit. En cliquant {cta} vous reconnaissez et acceptez les {rules}",
          "Official Rules": "Règlement officiel",
          Vote: "Voter",
          "Check In": "Enregistrement",
          "Search by artist name or venue...":
            "Recherchez par nom d'artiste ou lieu...",
          Submitting: "Envoi en cours",
          "No matches found...": "Aucun résultat trouvé...",
          "You have donated": "Vous avez fait un don",
          "Join the Light Show?": "Rejoindre le show lumineux ?",
          "Turn your brightness up and hold your phone high.":
            "Montez la luminosité et levez votre téléphone.",
          "Tap the screen anytime to exit.":
            "Touchez l'écran à tout moment pour quitter.",
          Join: "Rejoindre",
          "Not Now": "Pas maintenant",
          "Check In to Join": "Enregistrez-vous pour rejoindre",
          "Light up the crowd": "Illuminez le public",
          "Your phone is part of the show":
            "Votre téléphone fait partie du show",
          "Join in": "Rejoindre",
          "Exit Light Show": "Quitter le show lumineux",
        },
      },
    },
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
